import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import StateObserver from 'src/StateObserver';
import { downscale } from 'src/conf/scale';

export default class LeaderboardsHeader extends View {
  constructor(opts: ViewOpts) {
    super(opts);
    this.addTitleBackground();
    this.addTitle();
    this.addNavBackground();
    this.addSeperator();
  }

  private addTitleBackground() {
    new ImageScaleView({
      superview: this,
      image:
        'assets/ui/weeklyLeaderboard/popups/popupLeaderboards/leaderboards_page_header.png',
      width: this.style.width,
      height: downscale(185),
    });
  }

  private addNavBackground() {
    new ImageScaleView({
      superview: this,
      image:
        'assets/ui/weeklyLeaderboard/popups/popupLeaderboards/nav_background.png',
      width: this.style.width,
      height: downscale(168),
      y: downscale(185),
    });
  }

  private addSeperator() {
    new ImageScaleView({
      superview: this,
      image:
        'assets/ui/weeklyLeaderboard/popups/popupLeaderboards/leaderboards_page_seperator.png',
      width: this.style.width,
      height: 8,
      y: downscale(185) - 4,
    });
  }

  private addTitle() {
    const locale = StateObserver.getLocale();
    const width = locale === 'en' ? 749 : 470;
    const height = locale === 'en' ? 118 : 123;
    new ImageScaleView({
      superview: this,
      image: `assets/ui/weeklyLeaderboard/popups/popupLeaderboards/title_${locale}.png`,
      width: downscale(width),
      height: downscale(height),
      centerOnOrigin: true,
      x: this.style.width * 0.5,
      y: 60,
    });
  }
}
